export { PaintIcon } from './paint'
